import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelPackageReasonMiniEntity } from '../../domain/entities/CancelPackageReasonMiniEntity'
import type { CancelPackageReasonAdminListedDtoAdmin } from '@/backend/market'

export class CancelPackageReasonMiniModel extends CancelPackageReasonMiniEntity {
  constructor(dataDto: CancelPackageReasonAdminListedDtoAdmin) {
    super()
    mapEntityProperties<CancelPackageReasonMiniEntity>(this, dataDto)
  }
}

